import {Component, Inject, OnInit} from '@angular/core';
import {MAT_DIALOG_DATA} from '@angular/material/dialog';
import { MatTableDataSource } from '@angular/material/table';
import {AnnuityLetterService} from 'src/app/services/annuity-letter.service';

@Component({
  selector: 'app-annuity-values-dialog',
  templateUrl: './annuity-values-dialog.component.html',
  styleUrls: [ './annuity-values-dialog.component.scss' ]
})
export class AnnuityValuesDialogComponent implements OnInit {

  public local_title: string;
  public letter: any;

  public dataSource: MatTableDataSource<any>
  public displayedColumns: string[] = [ 'product_name', 'value', "free" ];

  public dataSourceSent: MatTableDataSource<any>
  public displayedSentColumns: string[] = [ 'product_name', 'value', "free" ];


  constructor (
    private _annuityLetterService: AnnuityLetterService,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) { }

  ngOnInit () {
    // console.log("dialog " + JSON.stringify(this.data.letter_sent))
    this.local_title = this.data.name + " - " + this.data.annuity_from + " - " + this.data.situation;
    // console.log("annuities:  " +  JSON.stringify(this.data.annuities));

    this.dataSource = new MatTableDataSource(this.data.annuities);

    if (this.data.letter_sent) {
      //  console.log("this.data.letter_sent: " + this.data.letter_sent)
      this.loadLetterSentSumary(this.data.letter_sent)
    }

  }

  async loadLetterSentSumary (letter_sent_id: any) {
    this._annuityLetterService.getLetterSentById(letter_sent_id)
      .then((result) => {
        if (result) {
          this.letter = result
          // console.log(JSON.stringify(this.letter.annuities));
          this.dataSourceSent = new MatTableDataSource(this.letter.annuities);
        }
      })

  }

}
